<template>
  <div class="boxWrapper">
    <van-form ref="formRef" @submit="onSubmit" :show-error="false">
      <div class="box">
        <div class="title">
          <span class="icon"></span>
          收货信息
        </div>
        <div class="content">
          <div class="subTitle">姓名</div>
          <van-field
            v-model="bilibiliOrderDetails.consignee"
            name="consignee"
            placeholder="请输入"
            maxlength="20"
            :rules="[{ required: true, message: '请填写姓名' }]"
          />
          <div class="subTitle">手机号</div>
          <van-field
            v-model="bilibiliOrderDetails.phone"
            name="phone"
            placeholder="请输入"
            maxlength="20"
            :rules="[{ required: true, message: '请填写手机号' }]"
          />
          <div class="subTitle">所在地区</div>
          <van-field readonly :rules="[{ required: true, message: '请选择地区' }]" clickable :value="local" right-icon="arrow" name="local" placeholder="点击选择省市区" @click="showArea = true" />
          <van-popup v-model="showArea" position="bottom">
            <van-area :area-list="areaList" @confirm="onConfirm" @cancel="showArea = false" />
          </van-popup>
          <div class="subTitle">详细地址</div>
          <van-field
            v-model="bilibiliOrderDetails.addressDetail"
            name="addressDetail"
            placeholder="请输入"
            type="textarea"
            autosize
            maxlength="255"
            :rules="[{ required: true, message: '请填写详细地址' }]"
          />
        </div>
      </div>

      <div class="footer">
        <div @click="onClickBtn" class="btn">提交</div>
      </div>
    </van-form>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { editOrderAddress } from '@/api/bilibiliShipments/index';
import { areaList } from '@vant/area-data';

export default {
  data() {
    return {
      local: '',
      areaList,
      showArea: false,
      address: {},
      courseId: this.$route.query.courseId || 1452,
      showCoursePicker: false,
      showSubjectPicker: false,
      courseList: ['2024考研语法阅读精讲班'], // 默认：2024考研语法阅读精讲班
      subjectList: ['英语一', '英语二'], // 默认： ['英语一', '英语二']
      ignoreSubjectCourse: [4409], // 不需要展示科目的课程
      ignoreSubject: ['政治'],
    };
  },
  props: {
    detail: {
      type: Object,
      default: () => {
      },
    },
  },
  computed: {
    ...mapState(['bilibiliOrderDetails']),
  },
  mounted() {
    this.address.province = this.bilibiliOrderDetails?.province;
    this.address.city = this.bilibiliOrderDetails?.city;
    this.address.area = this.bilibiliOrderDetails?.area;
    if (this.bilibiliOrderDetails?.province) {
      this.local = `${this.bilibiliOrderDetails?.province} ${this.bilibiliOrderDetails?.city} ${this.bilibiliOrderDetails?.area}`;
    }
  },
  methods: {
    // 省市区确认
    onConfirm(values) {
      this.address.province = values[0]?.name;
      this.address.city = values[1]?.name;
      this.address.area = values[2]?.name;
      this.local = values
        .filter((item) => !!item)
        .map((item) => item.name)
        .join(' ');
      this.showArea = false;
    },
    onSuccess() {
      this.$router.replace({
        path: `/bilibili-shipments/result?courseId=${this?.bilibiliOrderDetails?.bproductId}`,
      });
    },
    async onSubmit(value) {
      const toast1 = this.$toast.loading({
        message: '请求中...',
        forbidClick: true,
      });
      delete value.local;
      const params = {
        ...this.address,
        ...value,
        id: this.bilibiliOrderDetails?.id,
      };
      const res = await editOrderAddress(params);
      toast1.clear();
      if (res.code === 0) {
        this.onSuccess();
      } else {
        this.$toast(res.msg ?? '请求错误');
      }
    },
    onClickBtn() {
      this.$refs.formRef.submit();
    },
  },
};
</script>

<style lang="scss" scoped>

.boxWrapper {
  padding-bottom: 180px;
  padding-top: 24px;
}

.box {
  margin: 0 36px 22px;
  background: #FFFFFF;
  border-radius: 14px;

  .title {
    padding-top: 33px;
    font-size: 33px;
    font-weight: 500;
    color: #333333;

    .icon {
      display: inline-block;
      width: 7px;
      height: 29px;
      margin-right: 29px;
      background: #FF7F41;
    }
  }

  .subTitle {
    font-size: 25px;
    margin-bottom: 14px;
    margin-top: 29px;
  }

  .content {
    padding: 36px;
  }

  .tooltip {
    font-size: 22px;
    color: #999999;
    line-height: 31px;
  }

  .topMargin {
    margin-top: 14px;
  }
}

.footer {
  position: fixed;
  bottom: 0;
  width: 750px;
  height: 167px;
  background: #FFFFFF;
  box-shadow: 0px -4px 18px 0px rgba(0, 0, 0, 0.07);

  .btn {
    width: 678px;
    height: 80px;
    margin: 22px 0 0 36px;
    background: #FF7F41;
    border-radius: 45px;
    color: #fff;
    font-size: 29px;
    text-align: center;
    line-height: 80px;
  }
}
</style>
